// Iter 391 — Reusable Repeat Order marker untuk Mockup Offline & Shopee.
//   - RepeatOrderBadge: badge menyala jika is_repeat_order=true, menampilkan "Repeat dari …" bila repeat_ref ada.
//   - RepeatOrderFields: pasangan toggle + input referensi; label "Nota" (offline) atau "Pesanan" (online).
//   - Flag EKSPLISIT, tidak diturunkan dari kesamaan nama customer.
//   - Tidak memengaruhi workflow, status FIX/REVISI, atau duplikasi order.
import React from "react";
import { Repeat } from "lucide-react";

const CTX_LABEL = { offline: "Nota", online: "Pesanan" };

export function RepeatOrderBadge({ active, repeatRef = "", context = "offline", size = "normal", testid }) {
  if (!active) return null;
  const refLabel = CTX_LABEL[context] || CTX_LABEL.offline;
  const isCompact = size === "compact";
  return (
    <span
      className={`repeat-order-badge ${isCompact ? "repeat-order-badge-compact" : ""}`}
      data-testid={testid || "repeat-order-badge"}
      title={repeatRef ? `Repeat dari ${refLabel}: ${repeatRef}` : "Repeat Order"}>
      <Repeat size={isCompact ? 11 : 13} aria-hidden="true"/>
      <span className="repeat-order-badge-label">REPEAT ORDER</span>
      {repeatRef ? (
        <span className="repeat-order-badge-ref">
          <span className="repeat-order-badge-sep">·</span>
          {refLabel}: <b>{repeatRef}</b>
        </span>
      ) : null}
    </span>
  );
}

export function RepeatOrderFields({ active, repeatRef, onChange, context = "offline", disabled = false, idPrefix = "repeat-order" }) {
  const refLabel = CTX_LABEL[context] || CTX_LABEL.offline;
  const checkboxId = `${idPrefix}-toggle`;
  const inputId = `${idPrefix}-ref`;
  return (
    <div className="repeat-order-fields">
      <label className="repeat-order-toggle" htmlFor={checkboxId}>
        <input
          id={checkboxId}
          type="checkbox"
          checked={!!active}
          disabled={disabled}
          onChange={e => onChange && onChange({ is_repeat_order: e.target.checked, repeat_ref: repeatRef || "" })}
          data-testid={`${idPrefix}-toggle-input`}/>
        <span>Repeat Order</span>
      </label>
      {active && (
        <div className="repeat-order-ref-row">
          <label htmlFor={inputId} className="repeat-order-ref-label">Nomor {refLabel} Referensi <span className="muted small">(opsional)</span></label>
          <input
            id={inputId}
            type="text"
            value={repeatRef || ""}
            placeholder={context === "online" ? "Mis. 250901ABCXYZ" : "Mis. TMF-20250901-0012"}
            disabled={disabled}
            onChange={e => onChange && onChange({ is_repeat_order: !!active, repeat_ref: e.target.value })}
            className="repeat-order-ref-input"
            data-testid={`${idPrefix}-ref-input`}/>
        </div>
      )}
    </div>
  );
}
